import { render, staticRenderFns } from "./RxInformation.vue?vue&type=template&id=514a779a&scoped=true&"
import script from "./RxInformation.vue?vue&type=script&lang=js&"
export * from "./RxInformation.vue?vue&type=script&lang=js&"
import style0 from "./RxInformation.vue?vue&type=style&index=0&id=514a779a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a779a",
  null
  
)

export default component.exports